import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import {
    Row,
    Image,
    Button,
    Link,
} from 'yurstrap';

import { frontUrl } from '../../config';

import {
    openModal,
    acceptAllFromBanner,
    rejectAllFromBanner,
    getIsBannerHiddenSelector,
} from '../reduxModules/ConsentManagementPlatform';

import Scopes from '../../constants/Scopes';
import { getScopeSelector } from '../../commons/reduxModules/Authentication';

const propTypes = {
    AppActions: PropTypes.shape({
        openModal: PropTypes.func.isRequired,
        acceptAllFromBanner: PropTypes.func.isRequired,
        rejectAllFromBanner: PropTypes.func.isRequired,
    }).isRequired,
    isBannerHidden: PropTypes.bool.isRequired,
    scope: PropTypes.string.isRequired,
};

class CMPBanner extends Component {

    constructor(props) {
        super(props);
        this.onOpenModal = this.onOpenModal.bind(this);
        this.acceptAllFromBanner = this.acceptAllFromBanner.bind(this);
        this.rejectAllFromBanner = this.rejectAllFromBanner.bind(this);
    }

    onOpenModal() {
        const { AppActions } = this.props;
        AppActions.openModal();
    }

    acceptAllFromBanner() {
        const { AppActions } = this.props;
        AppActions.acceptAllFromBanner();
    }

    rejectAllFromBanner() {
        const { AppActions } = this.props;
        AppActions.rejectAllFromBanner();
    }

    render() {
        const {
            isBannerHidden,
            scope,
        } = this.props;
        if (isBannerHidden) return null;
        return (
            <div className={Scopes.PRO === scope ? 'c-cookie px-4 py-3 p--s-4' : 'c-cookie px-4 py-3 p--s-4'}>
                <Row
                    vcenter
                >
                    <div className="u-col--l u-col--m-12">
                        <Row vcenter noCol>
                            <Image
                                className="mr-3 u-display__none--s"
                                size="xs"
                                src="/img/illu__cookie.svg"
                                alt="cookie yurplan"
                            />
                            <div className="u-flex--1 pr-4 pr--s-0">
                                En poursuivant votre navigation vous acceptez le dépôt de cookies
                                tiers destinés à assurer et améliorer le fonctionnement du site,
                                vous proposer des contenus et publicités ciblés, et vous offrir
                                l'accès à des fonctionnalités supplémentaires (ex: connexion
                                via Facebook). Pour en savoir plus, consultez notre
                                {' '}
                                <Link
                                    href={`${frontUrl}/charte-cookies`}
                                >
                                    charte des cookies
                                </Link>
                                .
                            </div>
                        </Row>
                    </div>
                    <div className="u-col--l-auto u-col--m-12 mt--l-3">
                        <Button
                            onClick={this.acceptAllFromBanner}
                            className="mt--s-3 u-display__b--s"
                        >
                            Ok, tout accepter
                        </Button>
                        <Button
                            color="secondary"
                            onClick={this.rejectAllFromBanner}
                            className="mt--s-3 u-display__b--s"
                        >
                            Tout refuser
                        </Button>
                        <Button
                            color="secondary"
                            onClick={this.onOpenModal}
                        >
                            Personnaliser
                        </Button>
                    </div>
                </Row>
            </div>
        );
    }

}

CMPBanner.propTypes = propTypes;

function mapStateToProps(state) {
    return {
        isBannerHidden: getIsBannerHiddenSelector(state),
        scope: getScopeSelector(state),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        AppActions: bindActionCreators({
            openModal,
            acceptAllFromBanner,
            rejectAllFromBanner,
        }, dispatch),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(CMPBanner);
